<script>
import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';
import complex from '../../../../compoment/complex/complex';
import OrgList from './org-list.vue';
import ProductList from './product-list.vue';

formCreate.component('complex', complex);
formCreate.component('OrgList', OrgList);
formCreate.component('ProductList', ProductList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
    };
  },

  mounted() {
    this.getFormRule('channel-cost-config-form');
  },

  methods: {
    setRule(v) {
      const rowData = v;
      if (rowData.field === 'costEffectiveMethod') {
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            if (e === '2') {
              // 总量控制
              this.setValue({
                effective: null,
                feeType: null,
              });
              this.hiddenFields(true, ['effective', 'feeType']);
            } else {
              this.hiddenFields(false, ['effective', 'feeType']);
            }
          },
        };
      }
      if (rowData.field === 'productCode') {
        rowData.props = {
          ...rowData.props,
          paramsObj: {
            functionCode: 'product_list',
            data: [],
            idKey: 'productCode',
          },
          placeholder: '选择产品',
        };
        rowData.on = {
          ...rowData.on,
          change: (value) => {
            this.setValue({ productCode: value.productCode, productName: value.productName });
          },
        };
        // rowData.restful = '/mdm/mdmProductController/productSelectList';
        // rowData.optionsKey = {
        //   value: 'productCode',
        //   label: 'productCode',
        // };
        // rowData.props = {
        //   ...rowData.props,
        //   remoteParams: 'productCode',
        //   remote: true,
        //   filterable: true,
        // };
        // rowData.on = {
        //   ...rowData.on,
        //   getItem: (value) => {
        //     this.setValue({ productName: value.productName });
        //   },
        //   change: (value) => {
        //     this.setValue({ productCode: value });
        //   },
        // };
      }
      if (rowData.field === 'configRelCompanyList') { // 多选组织
        rowData.props = {
          ...rowData.props,
          params: {
            functionCode: 'org_list',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: rowData.title,
          autosize: { minRows: 1, maxRows: 6 },
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            const configRelCompanyList = [];
            e.forEach((m) => {
              const obj = m;
              configRelCompanyList.push({
                orgName: obj.orgName,
                orgCode: obj.orgCode,
              });
            });
            this.setValue({
              configRelCompanyList: configRelCompanyList || [],
            });
          },
        };
      }
      return rowData;
    },
    formComplete() {
      this.disabled(true, 'productName');
      if (this.formConfig.id) {
        this.getData(this.formConfig.id);
      }
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        this.hiddenFields(true, ['custTypes']);
      } else if (this.formConfig.code === 'add') {
        this.hiddenFields(true, ['custType']);
      }
      const controlType = this.getRule('controlType');
      const costGeneration = this.getRule('costGeneration');
      controlType.on = {
        ...controlType.on,
        change: (e) => {
          console.log(e);
          if (e === '1') {
            // 总量控制
            this.setValue({
              isSupplyBill: null,
            });
            this.hiddenFields(true, 'isSupplyBill');
          } else {
            this.hiddenFields(false, 'isSupplyBill');
          }

          console.log('costGeneration', costGeneration);
          if (e === '0' || e === '1') {
            this.updateRules({
              costGeneration: {
                options: costGeneration.options.map((ov) => {
                  console.log(ov);
                  const cc = ov;
                  cc.disabled = cc.value === '2';
                  return cc;
                }),
              },
            });
          }
          if (e === '2') {
            this.updateRules({
              costGeneration: {
                options: costGeneration.options.map((ov) => {
                  const cc = ov;
                  cc.disabled = cc.value === '1';
                  return cc;
                }),
              },
            });
          }

          this.setValue({
            costGeneration: null,
          });
        },
      };
      costGeneration.restful = '/mdm/mdmdictdata/list'; // 请求接口
      costGeneration.requestType = 'POST';// 请求方式
      costGeneration.restfulParams = { dictTypeCode: 'channel_cost_generation' }; // 请求参数
      costGeneration.optionsKey = {
        value: 'dictCode',
        label: 'dictValue',
      };
      costGeneration.on = {
        ...costGeneration.on,
        change: (value) => {
          this.setValue({ costGeneration: value });
        },
        optionCallback: (options) => {
          costGeneration.options = options.map((item) => {
            if (controlType.value === '1' || controlType.value === '0') {
              item.disabled = item.value === '2';
            }
            if (controlType.value === '2') {
              item.disabled = item.value === '1';
            }
            return item;
          });
        },

      };
    },

    async getData(id) {
      const { result } = await this.$http.post(
        '/dms/dms/channelFeeConfig/query',
        { id },
      );
      result.effective = {
        feeCreateDate: result.feeCreateDate,
        delayDay: result.delayDay,
        // unit: result.unit,
        delayType: result.delayType,
      };
      this.setValue({
        ...result,
      });
    },

    submit() {
      let params = this.getFormData();
      if (this.formConfig.code === 'add') {
        params.custType = params.custTypes.toString();
      }
      delete params.custTypes;
      let path = '/dms/dms/channelFeeConfig/save';
      if (this.formConfig.id) {
        path = '/dms/dms/channelFeeConfig/update';
        params.id = this.formConfig.id;
      }
      params = { ...params, ...params.effective };
      request.post(path, params).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功！');
          this.$emit('onClose');
          this.$emit('onGetList');
        } else {
          this.$message.error(res.messge);
        }
      });
    },
  },
};
</script>
